/** Shared GitHub Search API query builders */

export function lastActiveQualifier(value) {
  const now = new Date();
  if (value === "30d") {
    now.setDate(now.getDate() - 30);
  } else if (value === "6m") {
    now.setMonth(now.getMonth() - 6);
  } else if (value === "1y") {
    now.setFullYear(now.getFullYear() - 1);
  } else {
    return "";
  }
  const day = now.toISOString().slice(0, 10);
  return `pushed:>${day}`;
}

export function buildUserSearchQuery(text, filters = {}) {
  const parts = [];
  const t = (text || "").trim();
  const f = filters || {};

  if (f.usernameExact) {
    const u = f.usernameExact.replace(/^@/, "").trim();
    if (u) parts.push(`${u} in:login`);
  } else if (t) {
    parts.push(t);
  }

  if (f.nameKeyword && f.nameKeyword.trim()) {
    parts.push(`${f.nameKeyword.trim()} in:name`);
  }
  if (f.language && f.language.trim()) {
    parts.push(`language:${f.language.trim()}`);
  }
  if (f.topic && f.topic.trim()) {
    parts.push(`topic:${f.topic.trim()}`);
  }
  if (f.followersMin !== "" && f.followersMin != null && Number(f.followersMin) > 0) {
    parts.push(`followers:>=${Number(f.followersMin)}`);
  }
  if (f.followersMax !== "" && f.followersMax != null && Number(f.followersMax) > 0) {
    parts.push(`followers:<=${Number(f.followersMax)}`);
  }
  if (f.followingMin !== "" && f.followingMin != null && Number(f.followingMin) > 0) {
    parts.push(`following:>=${Number(f.followingMin)}`);
  }
  if (f.publicReposMin !== "" && f.publicReposMin != null && Number(f.publicReposMin) > 0) {
    parts.push(`repos:>=${Number(f.publicReposMin)}`);
  }
  if (f.lastActive) {
    const pushed = lastActiveQualifier(f.lastActive);
    if (pushed) parts.push(pushed);
  }
  if (f.repoNameKeyword && f.repoNameKeyword.trim()) {
    parts.push(`${f.repoNameKeyword.trim()} in:readme`);
  }

  parts.push("type:user");

  return parts.join(" ").trim();
}

/**
 * Repository search (/search/repositories)
 */
export function buildRepoSearchQuery(text, filters = {}) {
  const parts = [];
  const t = (text || "").trim();
  const f = filters || {};

  if (t) parts.push(t);
  if (f.language && String(f.language).trim()) {
    parts.push(`language:${String(f.language).trim()}`);
  }
  const minS = f.minStars !== "" && f.minStars != null ? Number(f.minStars) : 0;
  const maxS = f.maxStars !== "" && f.maxStars != null ? Number(f.maxStars) : 0;
  if (minS > 0 && maxS > 0 && maxS >= minS) {
    parts.push(`stars:${minS}..${maxS}`);
  } else if (minS > 0) {
    parts.push(`stars:>=${minS}`);
  } else if (maxS > 0) {
    parts.push(`stars:<=${maxS}`);
  }
  if (f.topic && f.topic.trim()) {
    parts.push(`topic:${f.topic.trim()}`);
  }
  if (f.forksMin !== "" && f.forksMin != null && Number(f.forksMin) > 0) {
    parts.push(`forks:>=${Number(f.forksMin)}`);
  }
  if (f.lastActive) {
    const pushed = lastActiveQualifier(f.lastActive);
    if (pushed) parts.push(pushed);
  }
  if (f.repoNameKeyword && f.repoNameKeyword.trim()) {
    parts.push(`${f.repoNameKeyword.trim()} in:readme`);
  }

  const q = parts.join(" ").trim();
  return q || "stars:>0";
}

/**
 * Repositories belonging to a user (profile tab)
 */
export function buildProfileReposQuery(login, text, filters = {}) {
  const parts = [`user:${login.replace(/^@/, "")}`];
  const t = (text || "").trim();
  if (t) {
    parts.push(`${t} in:name,description`);
  }
  if (filters.language && String(filters.language).trim()) {
    parts.push(`language:${String(filters.language).trim()}`);
  }
  return parts.join(" ") || `user:${login.replace(/^@/, "")}`;
}
